window.SUBX = {};

function parseJSON(value, fallback = null) {
  try {
    if (!value) return fallback;

    if (typeof value !== 'string') {
      return value;
    }

    value = value.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');

    let parsed = JSON.parse(value);

    if (Array.isArray(parsed) && parsed.length && typeof parsed[0] === 'string') {
      parsed = parsed.map(item => {
        try {
          return JSON.parse(item.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&'));
        } catch (e) {
          return item;
        }
      });
    }

    return parsed;
  } catch (e) {
    console.warn('SUBX parseJSON failed', e);
    return fallback;
  }
}

function getCurrentSection() {
  const section = document.querySelector('[id^="shopify-section-"]:has(.easymanualsubsection)');
  if (!section) return null;
  return section;
}

function getCurrentVariantId(variantInput, productData) {
  const urlVariant = new URLSearchParams(window.location.search).get('variant');

  if (urlVariant) {
    return urlVariant;
  }

  if (variantInput?.value) {
    return variantInput.value;
  }

  return productData?.selected_or_first_available_variant?.id || null;
}

function refreshSUBX() {
  const section = getCurrentSection();
  if (!section) return null;

  const SUBS_ELEMENT = section.querySelector('.easymanualsubsection');
  if (!SUBS_ELEMENT) {
    console.warn('SUBX: Subscription element not found');
    return null;
  }

  const sectionId = SUBS_ELEMENT.dataset.sectionId || null;
  const productId = SUBS_ELEMENT.dataset.productId || null;
  const shopifySection = document.querySelector(`#shopify-section-${sectionId}`) || document.querySelector(`#QuickAdd-${productId}`) || SUBS_ELEMENT.closest('[id^="shopify-section-"]') || document;
  const forms = [...shopifySection.querySelectorAll('[action*="/cart/add"]')];
  const variantInput = forms[1]?.querySelector('[name="id"]') || forms[0]?.querySelector('[name="id"]') || null;
  const productData = parseJSON(SUBS_ELEMENT.dataset.productJsonData, {});

  Object.assign(window.SUBX, {
    SUBS_ELEMENT,sectionId,productId,shopifySection,forms,variantInput,
    currentVariantId:getCurrentVariantId(variantInput, productData),
    giftIcon:SUBS_ELEMENT.dataset.giftIcon || '',
    variantIds:parseJSON(SUBS_ELEMENT.dataset.variantsList,[]),
    productJson:parseJSON(SUBS_ELEMENT.dataset.subscriptionLargeData),
    variantMeta:parseJSON(SUBS_ELEMENT.dataset.variantsMeta),
    styleMeta:parseJSON(SUBS_ELEMENT.dataset.subxStyleSetting),
    productMeta:parseJSON(SUBS_ELEMENT.dataset.productMetaData),
    gatewayMode:SUBS_ELEMENT.dataset.gatewayMode || '',
  });

  return window.SUBX;
}

function handleSUBXChange(type, value) {
  refreshSUBX();

  toggleSubscribeButton();
  
  document.dispatchEvent(new CustomEvent(`subx:${type}-change`, {
    detail:{value,SUBX}
  }));
}

function setupPurchaseOptionObserver() { 
  SUBX.SUBS_ELEMENT?.querySelectorAll('.easymsgradiobig').forEach(input => {
    if (input.dataset.subxBound) return;

    input.dataset.subxBound = 'true';

    input.addEventListener('change', () => {
      handleSUBXChange('purchase-option', input.id);
    });
  });
}

function setupSellingPlanObserver() {
  SUBX.SUBS_ELEMENT?.querySelectorAll('.easymsgsamllradio').forEach(input => {
    if (input.dataset.subxBound) return;

    input.dataset.subxBound = 'true';

    input.addEventListener('change', () => {
      handleSUBXChange('selling-plan', {
        sellingPlanId:input.dataset.sellingPlanId,
        sellingPlanName:input.dataset.sellingPlanName
      });
    });
  });
}

function setupVariantObserver() {
  setupUrlObserver();
  const productData = parseJSON(SUBX.SUBS_ELEMENT.dataset.productJsonData, {});
  const variantInput = SUBX.variantInput;

  if (!variantInput) {
    console.warn('SUBX: Variant input not found');
    return;
  }

  SUBX.currentVariantId = getCurrentVariantId(variantInput, productData);

  variantInput.addEventListener('change', e => {
    onVariantChange(e.target.value);
  });

  variantInput.addEventListener('input', e => {
    onVariantChange(e.target.value);
  });

  SUBX.variantObserver?.disconnect();

  SUBX.variantObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        const newValue = variantInput.value;

        if (newValue !== SUBX.currentVariantId) {
          onVariantChange(newValue);
        }
      }
    }
  });

  SUBX.variantObserver.observe(variantInput,{
    attributes:true,
    attributeFilter:['value']
  });
}

function setupUrlObserver() {
  if (SUBX.urlObserverInitialized) return;

  SUBX.urlObserverInitialized = true;

  window.addEventListener('popstate', () => {
    onUrlChange();
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = (...args) => {
    originalPushState.apply(history,args);
    onUrlChange();
  };

  history.replaceState = (...args) => {
    originalReplaceState.apply(history,args);
    onUrlChange();
  };
}

function onUrlChange() {
  const newVariantId = new URLSearchParams(window.location.search).get('variant');
  if (newVariantId && newVariantId !== SUBX.currentVariantId) {
    onVariantChange(newVariantId);
  }
}

function onVariantChange(newVariantId) {
  if (newVariantId === SUBX.currentVariantId) return;

  SUBX.currentVariantId = newVariantId;

  SUBX.forms?.forEach(form => {
    const subscribeBtn = form.querySelector('.subx-subscribe-btn');
    if (subscribeBtn) subscribeBtn.style.display = 'none';
  });

  clearTimeout(SUBX.variantChangeTimeout);

  SUBX.variantChangeTimeout = setTimeout(() => {
    refreshSUBX();
    handleSUBXChange('variant', newVariantId);
  }, 300);
}

function setupWidgetObserver() {
  SUBX.widgetObserver?.disconnect();
  SUBX.widgetObserver = new MutationObserver(() => {
    refreshSUBX();
    toggleSubscribeButton();
    setupPurchaseOptionObserver();
    setupSellingPlanObserver();
    setupVariantObserver();
  });

  SUBX.widgetObserver.observe(SUBX.SUBS_ELEMENT,{
    childList:true,
    subtree:true
  });
}

function ensureSubscribeButtons() {
  SUBX.forms.forEach(form => {
    const nativeBtn = form.querySelector('button[type="submit"], input[type="submit"]');

    if (!nativeBtn) return;

    let subscribeBtn = form.querySelector('.subx__subscribe-btn');

    if (!subscribeBtn) {
      subscribeBtn = nativeBtn.cloneNode(true);
      subscribeBtn.classList.add('subx__subscribe-btn');

      subscribeBtn.removeAttribute('id');
      subscribeBtn.removeAttribute('ref');
      subscribeBtn.removeAttribute('name');

      Array.from(subscribeBtn.attributes).forEach(attr => {
        if (attr.name.startsWith('on:')) {
          subscribeBtn.removeAttribute(attr.name);
        }
      });

      subscribeBtn.type = 'button';
      subscribeBtn.disabled = false;
      subscribeBtn.textContent = 'Subscribe Now';
      subscribeBtn.style.display = 'none';

      subscribeBtn.addEventListener('click', handleSubscribeButtonClick);

      nativeBtn.insertAdjacentElement('afterend', subscribeBtn);
    }
  });
}

function shouldShowSubscribeButton() {
  const isSubscription = !!SUBX.SUBS_ELEMENT?.querySelector('.easymsgsamllradio:checked');
  const isAvailable = isVariantAvailable();
  return (isAvailable && isSubscription && ['RAZORPAY', 'PAYSTACK', 'RAZORPAY_RECURRING'].includes(SUBX.gatewayMode?.toUpperCase()));
}

function isVariantAvailable() {
  const productData = parseJSON(SUBX.SUBS_ELEMENT.dataset.productJsonData, {});
  const variant = productData.variants?.find(v => String(v.id) === String(SUBX.currentVariantId));
  return variant?.available !== false;
}

function toggleSubscribeButton() {
  const shouldShow = shouldShowSubscribeButton();

  ensureSubscribeButtons();
  
  SUBX.forms.forEach(form => {
    const nativeBtn = form.querySelector('button[type="submit"]:not(.subx__subscribe-btn), input[type="submit"]:not(.subx__subscribe-btn)');
    const subscribeBtn = form.querySelector('.subx__subscribe-btn');
    form.classList.toggle('subx--subscription-active', shouldShow);
    if (nativeBtn) {
      nativeBtn.style.display = shouldShow ? 'none' : '';
    }

    if (subscribeBtn) {
      subscribeBtn.style.display = shouldShow ? 'block' : 'none';
    }
  });
}

function getSelectedSellingPlan() {
  return SUBX.SUBS_ELEMENT?.querySelector('.easymsgsamllradio:checked');
}

function getQuantity(form) {
  const qtyInput = form?.querySelector('[name="quantity"]');
  return parseInt(qtyInput?.value || '1', 10) || 1;
}

function getProductImage(variant) {
  const rawImage = variant?.featured_image?.src || variant?.image?.src || SUBX.productMeta?.[0]?.featured_image?.src || '';
  return rawImage.startsWith('//') ? `https:${rawImage}` : rawImage;
}

function getSelectedPlanRow(planId) {
  const planInput = SUBX.SUBS_ELEMENT?.querySelector(`input[data-selling-plan-id="${planId}"]:checked`);
  return planInput?.closest('.easymsgsubsplanlistcontainerlabCon') || null;
}

function getPlanPrice(planRow) {
  const priceElement = planRow?.querySelector('.easysellingplanallocationprice') || SUBX.SUBS_ELEMENT?.querySelector('.easymsgsubsplanprice');
  return priceElement?.textContent?.trim() || '';
}

function getTotalPrice(priceText, quantity) {
  const match = priceText.replace(/,/g, '').match(/\d+(\.\d+)?/);
  const numericPrice = match ? parseFloat(match[0]) : 0;

  return {
    numeric:numericPrice * quantity,
    formatted:priceText.replace(/\d+(\.\d+)?/, (numericPrice * quantity).toFixed(2))
  };
}

function getDiscountBadge(planRow) {
  return planRow?.querySelector('.easydiscountbadge')?.textContent?.trim() || '';
}

function getSubxPopupData(form) {
  const selectedPlan = getSelectedSellingPlan();
  if (!selectedPlan) {
    console.warn('SUBX: No selling plan selected');
    return null;
  }
  const sellingPlanId = selectedPlan.dataset.sellingPlanId || '';
  const sellingPlanName = selectedPlan.dataset.sellingPlanName || '';
  const quantity = getQuantity(form);
  const planRow = getSelectedPlanRow(sellingPlanId);
  const pricePerCycle = getPlanPrice(planRow);
  const discountBadgeText = getDiscountBadge(planRow);
  const totalPrice = getTotalPrice(pricePerCycle, quantity);

  const productData = JSON.parse(SUBX.SUBS_ELEMENT.dataset.productJsonData || '{}');
  const variant = productData.variants?.find( v => String(v.id) === String(SUBX.variantInput.value));
  const rawImg = variant?.featured_image?.src || variant?.image?.src ||  productData?.featured_image ||  productData?.images?.[0] || '';

  const imageUrl = rawImg && rawImg.startsWith('//') ? `https:${rawImg}` : rawImg;

  const productName = productData?.title || '';
  const variantTitle = variant?.title || '';

  return {
    shop: Shopify?.shop || '',
    gateway: SUBX.gatewayMode || '',
    productName: productName || '',
    variantTitle: variantTitle || '',
    imageUrl: imageUrl,
    variantId: `gid://shopify/ProductVariant/${SUBX.currentVariantId}`,
    variantNumericId: SUBX.currentVariantId,
    sellingPlanId,
    sellingPlanName,
    pricePerCycle,
    totalPricePerCycle: totalPrice.formatted,
    totalPriceNumeric: totalPrice.numeric,
    discountBadgeText,
    quantity,
    customerLoggedIn: SUBX.SUBS_ELEMENT.dataset.customerLoggedIn === 'true',
    customerEmail: SUBX.SUBS_ELEMENT.dataset.customerEmail || '',
    customerFirstName: SUBX.SUBS_ELEMENT.dataset.customerFirstName || '',
    customerLastName: SUBX.SUBS_ELEMENT.dataset.customerLastName || '',
    customerPhone: SUBX.SUBS_ELEMENT.dataset.customerPhone || '',
    customerAddress: parseJSON(SUBX.SUBS_ELEMENT.dataset.customerDefaultAddress),
    loginUrl: SUBX.SUBS_ELEMENT.dataset.loginUrl || '/account/login'
  };
}

function handleSubscribeButtonClick(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const form = event.currentTarget.closest('form');

  if (!form) return;

  const SubxPopupData = getSubxPopupData(form);
  openCheckoutPopup(SubxPopupData);
}

function initSUBX() {
  refreshSUBX();
  toggleSubscribeButton();  

  setupPurchaseOptionObserver();
  setupSellingPlanObserver();
  setupVariantObserver();
  setupWidgetObserver();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSUBX);
} else {
  initSUBX();
}

window.SUBX.popup = {instance: null};

function initPopup() {
  if (window.SUBX.popup.instance) return;
  window.SUBX.popup.instance = window.SUBXCheckoutPopup;
}

function openCheckoutPopup(data) {
  initPopup();

  if (!window.SUBX.popup.instance) {
    console.warn('SUBX Popup not available');
    return;
  }

  window.SUBX.popup.instance.open(data);
}

(function () {
  'use strict';
  var SUBX_APP_URL = 'https://apps.easysubscription.io';
  // Shop-specific: the direct link to this store's "Subscriptions" page in the new
  // customer accounts UI (Shopify assigns this ID per shop at install time, with no
  // way to compute it — copy it from the account page's address bar for each store
  // this file gets uploaded to). Falls back to the generic /account root if left blank.
  var SUBX_ACCOUNT_SUBSCRIPTIONS_URL = 'https://shopify.com/81300848697/account/pages/d8b7e920-2e71-4d67-854d-77ce0b6ef737';

  // Lazily loads Razorpay's Checkout.js (once) and resolves with window.Razorpay.
  // Used so the mandate/first-charge payment happens in-page instead of a full-page
  // redirect to Razorpay's hosted short_url — that hosted page has no way to send the
  // customer back to the store afterwards, which is the whole reason for this change.
  var razorpayScriptPromise = null;
  function loadRazorpayCheckout() {
    if (window.Razorpay) return Promise.resolve(window.Razorpay);
    if (razorpayScriptPromise) return razorpayScriptPromise;
    razorpayScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = function () {
        if (window.Razorpay) resolve(window.Razorpay);
        else reject(new Error('Razorpay Checkout failed to initialize'));
      };
      script.onerror = function () {
        razorpayScriptPromise = null;
        reject(new Error('Failed to load Razorpay Checkout script'));
      };
      document.head.appendChild(script);
    });
    return razorpayScriptPromise;
  }

  var POPUP_CSS = [
    '#subx__cp-overlay{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);',
    'display:flex;align-items:center;justify-content:center;padding:12px;box-sizing:border-box;',
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;overscroll-behavior:none;}',
    '#subx__cp-overlay[hidden]{display:none!important;}',
    
    '#subx__cp-overlay,#subx__cp-overlay *{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    // A universal selector (the rule above) matches real elements only — it does not reach
    // pseudo-elements like ::placeholder, which need their own explicit selector. Input
    // placeholder text ("First name", "House / Flat / Street", etc.) is rendered through
    // ::placeholder, so a theme's own input::placeholder rule (very common — many themes
    // style placeholder text with a wide letter-spacing or different font for a muted look)
    // still leaks through there even though every other piece of popup text is already fixed.
    '#subx__cp-overlay input::placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay input::-webkit-input-placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay input:-ms-input-placeholder{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;letter-spacing:normal!important;}',

    '.subx__cp-modal{background:#fff;border-radius:14px;width:100%;max-width:940px;max-height:92vh;',
    'overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.22);display:flex;flex-direction:column;overscroll-behavior:contain;}',
    '.subx__cp-modal::-webkit-scrollbar{width:4px;}',
    '.subx__cp-modal::-webkit-scrollbar-thumb{background:#ddd;border-radius:4px;}',

    '.subx__cp-header{display:flex;align-items:center;justify-content:space-between;',
    'padding:18px 24px 14px;border-bottom:1px solid #f0f0f0;',
    'position:sticky;top:0;background:#fff;z-index:10;}',
    '.subx__cp-header h2{margin:0;font-size:17px;font-weight:700;color:#111;}',
    '.subx__cp-close{background:#f4f4f4;border:none;width:30px;height:30px;border-radius:50%;',
    'font-size:16px;cursor:pointer;color:#555;padding:0;display:flex;align-items:center;justify-content:center;}',
    '.subx__cp-close:hover{background:#e8e8e8;}',

    '.subx__cp-grid{display:grid;grid-template-columns:1.15fr .85fr;grid-template-areas:"form summary";}',
    '.subx__cp-col-form{grid-area:form;padding:20px 24px;}',
    
    '.subx__cp-col-summary{grid-area:summary;padding:20px 24px;background:#fafafa;border-left:1px solid #f0f0f0;',
    'align-self:start;position:sticky;top:0;}',
    '#subx__cp-overlay .subx__cp-col-title{margin:0 0 16px;font-size:13px;font-weight:700;',
    'text-transform:uppercase;letter-spacing:.6px!important;color:#333;}',

    '.subx__cp-section{padding:14px 0;border-bottom:1px solid #f0f0f0;}',
    '.subx__cp-section:first-child{padding-top:0;}',
    '.subx__cp-section:last-child{border-bottom:none;}',
    '.subx__cp-section-title{margin:0 0 12px;font-size:13px;font-weight:700;color:#333;}',
    '.subx__cp-row{margin-bottom:10px;}.subx__cp-row:last-child{margin-bottom:0;}',
    '.subx__cp-row-2{display:grid;grid-template-columns:1fr 1fr;gap:10px;}',
    '.subx__cp-field label{display:block;font-size:12px;font-weight:600;color:#444;margin-bottom:5px;}',
    '.subx__cp-field input,.subx__cp-field select{width:100%;box-sizing:border-box;border:1.5px solid #e0e0e0;',
    'border-radius:8px;padding:10px 13px;font-size:14px;color:#111;outline:none;background:#fff;',
    'font-family:inherit;transition:border-color .15s,box-shadow .15s;}',
    '.subx__cp-field input:focus,.subx__cp-field select:focus{border-color:#1a7c3e;box-shadow:0 0 0 3px rgba(26,124,62,.1);}',
    '.subx__cp-field input.subx__cp-invalid,.subx__cp-field select.subx__cp-invalid{border-color:#d93025;background:#fff8f8;}',
    '.subx__cp-field-err{font-size:11px;color:#d93025;margin-top:3px;display:none;}',
    '.subx__cp-field-err.subx__cp-show{display:block;}',
    '.subx__cp-row-checkbox{margin-bottom:18px!important;}',
    '.subx__cp-login-banner{background:#eef6fd;border:1px solid #cfe6fa;border-radius:10px;',
    'padding:14px 16px;margin:4px 0 14px;}',
    '.subx__cp-login-title{font-size:14px;font-weight:700;color:#111;margin:0 0 4px;}',
    '.subx__cp-login-desc{font-size:12px;color:#666;margin:0 0 12px;line-height:1.5;}',
    '.subx__cp-login-btn{display:inline-block;background:#000;color:#fff;padding:9px 18px;',
    'border-radius:7px;font-size:13px;font-weight:700;text-decoration:none;}',
    '.subx__cp-login-btn:hover{background:#222;}',
    '.subx__cp-checkbox-label{display:flex;align-items:center;gap:9px;font-size:13px;color:#444;cursor:pointer;}',
    '.subx__cp-checkbox-label input{width:18px;height:18px;margin:0;cursor:pointer;flex-shrink:0;',
    'accent-color:#000;border-radius:4px;}',

    '.subx__cp-sum-product{display:flex;gap:12px;align-items:center;margin-bottom:14px;}',
    '#subx__cp-img-wrap{width:54px;height:54px;border-radius:8px;flex-shrink:0;',
    'display:flex;align-items:center;justify-content:center;background:#eee;font-size:20px;overflow:hidden;}',
    '#subx__cp-img-wrap img{width:54px;height:54px;border-radius:8px;object-fit:cover;border:1px solid #eee;}',
    '#subx__cp-product-name{font-size:14px;font-weight:700;color:#111;margin:0 0 3px;}',
    '#subx__cp-plan-name{font-size:12px;color:#666;margin:0;}',
    '.subx__cp-sum-divider{border-top:1px solid #e6e6e6;margin:14px 0;}',
    '.subx__cp-sum-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}',
    '.subx__cp-sum-row:last-child{margin-bottom:0;}',
    '.subx__cp-sum-label{font-size:13px;color:#666;}',
    '.subx__cp-sum-value{font-size:13px;color:#111;font-weight:600;}',
    '.subx__cp-shipping-note{font-size:12px;color:#888;font-weight:500;font-style:italic;',
    'text-align:right;max-width:60%;}',
    '.subx__cp-sum-total .subx__cp-sum-label{font-size:14px;color:#111;font-weight:700;}',
    '.subx__cp-sum-total .subx__cp-sum-value{font-size:16px;color:#111;font-weight:800;}',
    '#subx__cp-variant-display{display:block;width:100%;box-sizing:border-box;border:1.5px solid #e6e6e6;',
    'border-radius:8px;padding:9px 12px;font-size:13px;color:#333;background:#fff;}',

    // Every visual property here gets !important, not just font-family/letter-spacing —
    // border-radius specifically was found leaking on a live store (some themes apply
    // !important to their own button radius/border/background for sitewide CTA styling,
    // which beats a plain, non-!important declaration regardless of our selector's
    // specificity). Hardening the whole rule avoids finding these one property at a time.
    '#subx__cp-overlay .subx__cp-btn-submit{width:100%!important;padding:14px 20px!important;border:none!important;border-radius:9px!important;margin:16px 0!important;',
    'background:#000!important;color:#fff!important;font-size:14px!important;font-weight:700!important;cursor:pointer!important;',
    'letter-spacing:.4px!important;text-transform:uppercase!important;transition:background .15s!important;}',
    '#subx__cp-overlay .subx__cp-btn-submit:hover:not(:disabled){background:#222!important;}',
    '#subx__cp-overlay .subx__cp-btn-submit:disabled{opacity:.6!important;cursor:not-allowed!important;}',

    '.subx__cp-info-box{border:1px solid #e3def7;background:#f8f6ff;border-radius:10px;',
    'padding:12px 14px;margin-bottom:12px;}',
    '.subx__cp-info-box p{margin:0;}',
    '.subx__cp-info-title{font-size:13px;font-weight:700;color:#111;margin-bottom:4px;}',
    '.subx__cp-info-body{font-size:12px;color:#666;line-height:1.5;}',
    '.subx__cp-info-divider{border-top:1px solid #e3def7;margin:10px 0;}',

    '.subx__cp-global-err{font-size:13px;color:#d93025;margin:0 0 10px;',
    'display:none;padding:8px 12px;background:#fff0f0;border-radius:6px;}',
    '.subx__cp-global-err.subx__cp-show{display:block;}',

    // Shipping rate picker (summary column).
    '#subx__cp-shipping-options{margin:10px 0 4px;}',
    '.subx__cp-ship-label{display:block;font-size:12px;font-weight:600;color:#444;margin-bottom:6px;}',
    // One option per row, full width. Hardened the same way as the submit button: a theme
    // whose own <label> rule wins (an id-scoped selector, or !important) turns these rows
    // into shrink-to-fit inline boxes that sit side by side — seen on a live store.
    '#subx__cp-overlay .subx__cp-ship-rate{display:flex!important;align-items:center!important;gap:8px!important;',
    'padding:9px 10px!important;border:1px solid #e5e5e5!important;border-radius:7px!important;',
    'margin:0 0 6px!important;width:100%!important;box-sizing:border-box!important;float:none!important;',
    'cursor:pointer!important;font-size:13px!important;font-weight:400!important;text-transform:none!important;',
    'color:#111!important;background:#fff!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate input{margin:0!important;flex:0 0 auto!important;',
    'width:16px!important;height:16px!important;accent-color:#000!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-title{flex:1 1 auto!important;min-width:0!important;text-align:left!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-sub{display:block!important;font-size:11px!important;color:#777!important;',
    'font-weight:500!important;margin-top:2px!important;}',
    '#subx__cp-overlay .subx__cp-ship-rate-price{flex:0 0 auto!important;font-weight:700!important;white-space:nowrap!important;}',
    // Ship / Pickup tabs, like Shopify checkout. !important: themes style every <button>.
    '.subx__cp-ship-tabs{display:flex;gap:8px;margin:0 0 8px;}',
    '#subx__cp-overlay .subx__cp-ship-tab{flex:1 1 0!important;width:auto!important;margin:0!important;padding:9px 10px!important;',
    'border:1px solid #e5e5e5!important;border-radius:7px!important;background:#fff!important;color:#111!important;',
    'font-size:13px!important;font-weight:600!important;cursor:pointer!important;text-transform:none!important;letter-spacing:normal!important;}',
    '#subx__cp-overlay .subx__cp-ship-tab.subx__cp-active{border-color:#000!important;box-shadow:inset 0 0 0 1px #000!important;}',
    '.subx__cp-ship-status{font-size:12px;color:#888;font-style:italic;margin:4px 0 8px;text-align:right;}',
    '.subx__cp-ship-status.subx__cp-ship-error{color:#d93025;font-style:normal;}',
    // !important for the same reason as the submit button: themes style every <button>.
    '#subx__cp-overlay .subx__cp-ship-retry{background:none!important;border:none!important;padding:0!important;margin:0!important;',
    'width:auto!important;color:#1a5fb4!important;text-decoration:underline!important;cursor:pointer!important;',
    'font-size:12px!important;font-weight:600!important;text-transform:none!important;}',

    '@media(max-width:720px){',
    '.subx__cp-grid{grid-template-columns:1fr;grid-template-areas:"summary" "form";}',
    // Stacked single-column layout here — pinning the summary would just eat scroll space on
    // a small screen instead of helping, so undo the sticky behavior from the desktop rule.
    '.subx__cp-col-summary{border-left:none;border-bottom:1px solid #f0f0f0;position:static;}',
    '.subx__cp-row-2{grid-template-columns:1fr;}',
    '.subx__cp-col-form,.subx__cp-col-summary{padding:16px;}',
    '.subx__cp-header{padding-left:16px;padding-right:16px;}',
    '}',
    '.subx--subscription-active button[type="submit"]:not(.subx__subscribe-btn){display:none!important;}'
  ].join('');

  // ── HTML injected once into <body> ────────────────────────────────────────

  var POPUP_HTML = '<div id="subx__cp-overlay" hidden>' +
    '<div class="subx__cp-modal" role="dialog" aria-modal="true" aria-labelledby="subx__cp-title">' +

    '<div class="subx__cp-header">' +
    '<h2 id="subx__cp-title">Checkout Details</h2>' +
    '<button class="subx__cp-close" type="button" aria-label="Close">&#x2715;</button>' +
    '</div>' +

    '<div class="subx__cp-grid">' +

    // ── Left column: Checkout Details ──
    '<div class="subx__cp-col-form">' +

    '<div class="subx__cp-section">' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-email">Email *</label>' +
    '<input id="subx__cp-email" type="email" placeholder="Enter your email address" autocomplete="email"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-email-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-login-banner" id="subx__cp-login-banner" style="display:none;">' +
    '<p class="subx__cp-login-title">Login to use saved addresses</p>' +
    '<p class="subx__cp-login-desc">Sign in to your account to quickly select from your saved delivery addresses and enjoy a faster checkout experience.</p>' +
    '<a href="/account/login" id="subx__cp-login-btn" class="subx__cp-login-btn">Login</a>' +
    '</div>' +
    '</div>' +

    '<div class="subx__cp-section">' +
    '<p class="subx__cp-section-title">Shipping Information</p>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-fname">First Name *</label>' +
    '<input id="subx__cp-fname" type="text" placeholder="First name" autocomplete="given-name"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-fname-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-lname">Last Name *</label>' +
    '<input id="subx__cp-lname" type="text" placeholder="Last name" autocomplete="family-name"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-lname-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-addr1">Address Line 1 *</label>' +
    '<input id="subx__cp-addr1" type="text" placeholder="House / Flat / Street" autocomplete="address-line1"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-addr1-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-addr2">Address Line 2 (Optional)</label>' +
    '<input id="subx__cp-addr2" type="text" placeholder="Area / Landmark (optional)" autocomplete="address-line2"/>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-country">Country *</label>' +
    '<select id="subx__cp-country" autocomplete="country-name"></select>' +
    '<span class="subx__cp-field-err" id="subx__cp-country-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-province-select">State / Province *</label>' +
    '<select id="subx__cp-province-select" autocomplete="address-level1"></select>' +
    '<input id="subx__cp-province-text" type="text" placeholder="State / Province" autocomplete="address-level1" style="display:none;"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-province-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-city">City *</label>' +
    '<input id="subx__cp-city" type="text" placeholder="City" autocomplete="address-level2"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-city-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-zip">ZIP / Postal *</label>' +
    '<input id="subx__cp-zip" type="text" placeholder="400001" autocomplete="postal-code"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-zip-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-phone">Phone Number *</label>' +
    '<input id="subx__cp-phone" type="tel" placeholder="+91 98765 43210" autocomplete="tel"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-phone-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-checkbox">' +
    '<label class="subx__cp-checkbox-label" for="subx__cp-billing-same">' +
    '<input type="checkbox" id="subx__cp-billing-same" checked/>' +
    '<span>Billing address same as shipping</span>' +
    '</label>' +
    '</div>' +
    '</div>' +

    '<div class="subx__cp-section" id="subx__cp-billing-section" style="display:none;">' +
    '<p class="subx__cp-section-title">Billing Information</p>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-billing-addr1">Address Line 1 *</label>' +
    '<input id="subx__cp-billing-addr1" type="text" placeholder="House / Flat / Street" autocomplete="billing address-line1"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-addr1-err"></span>' +
    '</div></div>' +
    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label for="subx__cp-billing-addr2">Address Line 2 (Optional)</label>' +
    '<input id="subx__cp-billing-addr2" type="text" placeholder="Area / Landmark (optional)" autocomplete="billing address-line2"/>' +
    '</div></div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-country">Country *</label>' +
    '<select id="subx__cp-billing-country" autocomplete="billing country-name"></select>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-country-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-province-select">State / Province *</label>' +
    '<select id="subx__cp-billing-province-select" autocomplete="billing address-level1"></select>' +
    '<input id="subx__cp-billing-province-text" type="text" placeholder="State / Province" autocomplete="billing address-level1" style="display:none;"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-province-err"></span></div>' +
    '</div>' +
    '<div class="subx__cp-row subx__cp-row-2">' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-city">City *</label>' +
    '<input id="subx__cp-billing-city" type="text" placeholder="City" autocomplete="billing address-level2"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-city-err"></span></div>' +
    '<div class="subx__cp-field"><label for="subx__cp-billing-zip">ZIP / Postal *</label>' +
    '<input id="subx__cp-billing-zip" type="text" placeholder="400001" autocomplete="billing postal-code"/>' +
    '<span class="subx__cp-field-err" id="subx__cp-billing-zip-err"></span></div>' +
    '</div>' +
    '</div>' +

    '</div>' + // end .subx__cp-col-form

    // ── Right column: Subscription Summary ──
    '<div class="subx__cp-col-summary">' +
    '<p class="subx__cp-col-title">Subscription Summary</p>' +

    '<div class="subx__cp-sum-product">' +
    '<div id="subx__cp-img-wrap">&#128717;</div>' +
    '<div>' +
    '<p id="subx__cp-product-name"></p>' +
    '<p id="subx__cp-plan-name"></p>' +
    '</div></div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-row"><div class="subx__cp-field">' +
    '<label>Variant</label>' +
    '<span id="subx__cp-variant-display"></span>' +
    '</div></div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-sum-row">' +
    '<span class="subx__cp-sum-label">Plan Price</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-sum-plan-price"></span>' +
    '</div>' +
    '<div class="subx__cp-sum-row">' +
    '<span class="subx__cp-sum-label" id="subx__cp-shipping-label">Shipping</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-shipping-price">—</span>' +
    '</div>' +
    '<p id="subx__cp-shipping-status" class="subx__cp-ship-status" style="display:none;"></p>' +
    '<div id="subx__cp-shipping-options" style="display:none;">' +
    '<span class="subx__cp-ship-label" id="subx__cp-shipping-options-label">Shipping Method</span>' +
    '<div id="subx__cp-ship-tabs" class="subx__cp-ship-tabs" style="display:none;">' +
    '<button type="button" class="subx__cp-ship-tab" data-mode="SHIP" aria-pressed="true">Ship</button>' +
    '<button type="button" class="subx__cp-ship-tab" data-mode="PICKUP" aria-pressed="false">Pickup</button>' +
    '</div>' +
    '<div id="subx__cp-shipping-list"></div>' +
    '</div>' +

    '<div class="subx__cp-sum-divider"></div>' +

    '<div class="subx__cp-sum-row subx__cp-sum-total">' +
    '<span class="subx__cp-sum-label">Subscription Total</span>' +
    '<span class="subx__cp-sum-value" id="subx__cp-sum-total"></span>' +
    '</div>' +

    '<p id="subx__cp-global-err" class="subx__cp-global-err"></p>' +
    '<button type="button" id="subx__cp-submit" class="subx__cp-btn-submit">Proceed to Payment</button>' +

    '<div class="subx__cp-info-box">' +
    '<p class="subx__cp-info-title" id="subx__cp-info-discount-title">Subscribe once and enjoy ongoing savings on future orders</p>' +
    '<p class="subx__cp-info-body">Automatic deliveries at your chosen interval. Easy to manage, cancel anytime.</p>' +
    '<div class="subx__cp-info-divider"></div>' +
    '<p class="subx__cp-info-title">How to Subscribe</p>' +
    '<p class="subx__cp-info-body">Enable a UPI mandate to automate payments for recurring orders.</p>' +
    '</div>' +

    '</div>' + // end .subx__cp-col-summary

    '</div>' + // end .subx__cp-grid

    '</div></div>';

  // ── Country / State static lists ──────────────────────────────────────────
  // State select is shown for India only; other countries fall back to a free-text input.

  var COUNTRY_LIST = ['India', 'United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'France',
    'Italy', 'Spain', 'Netherlands', 'Belgium', 'Switzerland', 'Austria', 'Sweden', 'Norway', 'Denmark', 'Finland',
    'Ireland', 'Portugal', 'Poland', 'Greece', 'New Zealand', 'Singapore', 'United Arab Emirates', 'Saudi Arabia',
    'South Africa', 'Japan', 'South Korea', 'China', 'Hong Kong', 'Malaysia', 'Indonesia', 'Thailand', 'Philippines',
    'Vietnam', 'Pakistan', 'Bangladesh', 'Sri Lanka', 'Nepal', 'Brazil', 'Mexico', 'Argentina', 'Chile', 'Colombia',
    'Peru', 'Russia', 'Turkey', 'Israel', 'Egypt', 'Nigeria', 'Kenya'];

  var INDIA_STATES = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat',
    'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
    'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep',
    'Puducherry'];

  // ── Popup class ───────────────────────────────────────────────────────────

  function SubxCheckoutPopup() {
    this._options = {};
    this._overlay = null;
    this._ready = false;
    var self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { self._init(); });
    } else {
      this._init();
    }
  }

  SubxCheckoutPopup.prototype._init = function () {
    if (this._ready) return;
    // Inject CSS
    if (!document.getElementById('subx__cp-styles')) {
      var s = document.createElement('style');
      s.id = 'subx__cp-styles';
      s.textContent = POPUP_CSS;
      document.head.appendChild(s);
    }
    // Inject HTML
    if (!document.getElementById('subx__cp-overlay')) {
      var wrap = document.createElement('div');
      wrap.innerHTML = POPUP_HTML;
      document.body.appendChild(wrap.firstElementChild);
    }
    this._overlay = document.getElementById('subx__cp-overlay');
    this._populateLocationSelects();
    this._bindEvents();
    this._ready = true;
  };

  // Shared by shipping (subx__cp-*) and billing (subx__cp-billing-*) field groups.
  SubxCheckoutPopup.prototype._populateLocationSelects = function () {
    this._populateCountrySelect('subx__cp-country');
    this._populateCountrySelect('subx__cp-billing-country');
    this._populateStateSelect('subx__cp-province-select');
    this._populateStateSelect('subx__cp-billing-province-select');
    this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    this._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
  };

  SubxCheckoutPopup.prototype._populateCountrySelect = function (countryId) {
    var countrySel = document.getElementById(countryId);
    if (countrySel && !countrySel.options.length) {
      COUNTRY_LIST.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name; opt.textContent = name;
        countrySel.appendChild(opt);
      });
      countrySel.value = 'India';
    }
  };

  SubxCheckoutPopup.prototype._populateStateSelect = function (stateSelectId) {
    var stateSel = document.getElementById(stateSelectId);
    if (stateSel && !stateSel.options.length) {
      // An empty first option, so a customer who never opens the list can't silently send
      // the first state in the alphabet. Real orders went out as "455001 dewas AP" and
      // Shopify flagged "Review address issues"; _validate now makes them choose.
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select state';
      stateSel.appendChild(placeholder);
      INDIA_STATES.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name; opt.textContent = name;
        stateSel.appendChild(opt);
      });
    }
  };

  // Shows the State <select> for India, falls back to a free-text input for any other country.
  SubxCheckoutPopup.prototype._onCountryChange = function (countryId, stateSelectId, stateTextId) {
    var country = (document.getElementById(countryId) || {}).value || '';
    var stateSel = document.getElementById(stateSelectId);
    var stateText = document.getElementById(stateTextId);
    if (!stateSel || !stateText) return;
    if (country === 'India') {
      stateSel.style.display = '';
      stateText.style.display = 'none';
    } else {
      stateSel.style.display = 'none';
      stateText.style.display = '';
    }
  };

  // Returns whichever State/Province field is currently visible (select for India, text otherwise).
  SubxCheckoutPopup.prototype._getActiveProvinceEl = function (stateSelectId, stateTextId) {
    var stateSel = document.getElementById(stateSelectId);
    if (stateSel && stateSel.style.display !== 'none') return stateSel;
    return document.getElementById(stateTextId);
  };

  SubxCheckoutPopup.prototype._bindEvents = function () {
    var self = this;
    var overlay = this._overlay;
    if (!overlay) return;
    var countrySel = document.getElementById('subx__cp-country');
    if (countrySel) countrySel.addEventListener('change', function () {
      self._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    });
    var billingCountrySel = document.getElementById('subx__cp-billing-country');
    if (billingCountrySel) billingCountrySel.addEventListener('change', function () {
      self._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
    });
    var billingSameCheckbox = document.getElementById('subx__cp-billing-same');
    var billingSection = document.getElementById('subx__cp-billing-section');
    if (billingSameCheckbox && billingSection) {
      billingSameCheckbox.addEventListener('change', function () {
        billingSection.style.display = billingSameCheckbox.checked ? 'none' : '';
      });
    }
    overlay.querySelector('.subx__cp-close').addEventListener('click', function () { self.close(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) self.close();
    });
    document.getElementById('subx__cp-submit').addEventListener('click', function () { self._handleSubmit(); });
    // Any change to the SHIPPING address re-quotes shipping. Billing fields don't affect it.
    ['subx__cp-addr1', 'subx__cp-addr2', 'subx__cp-city', 'subx__cp-province-select',
      'subx__cp-province-text', 'subx__cp-country', 'subx__cp-zip'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () { self._onShippingAddressChanged(); });
      el.addEventListener('change', function () { self._onShippingAddressChanged(); });
    });
    // Ship / Pickup tabs.
    overlay.querySelectorAll('.subx__cp-ship-tab').forEach(function (tab) {
      tab.addEventListener('click', function () { self._selectShippingMode(tab.getAttribute('data-mode')); });
    });
  };

  SubxCheckoutPopup.prototype.open = function (options) {
    var self = this;
    if (!this._ready) { setTimeout(function () { self.open(options); }, 80); return; }
    this._options = options || {};
    this._clearErrors();
    this._resetForm();
    this._fillSummary();
    this._applyCustomerLoginState();
    // A saved address is filled in by code, which fires no input event — quote it now,
    // or a logged-in customer would never see (or pay) shipping.
    this._onShippingAddressChanged(true);
    this._overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      var first = document.getElementById('subx__cp-email');
      if (first) first.focus();
    }, 80);
  };

  // Logged-in customers: hide the login banner and auto-fill name/email/phone/address
  // from their Shopify account (passed in via data-customer-* attributes from ms.liquid).
  // Logged-out: show the "Login to use saved addresses" banner with a return-to-this-page link.
  SubxCheckoutPopup.prototype._applyCustomerLoginState = function () {
    var o = this._options;
    var banner = document.getElementById('subx__cp-login-banner');
    var loginBtn = document.getElementById('subx__cp-login-btn');

    if (!o.customerLoggedIn) {
      if (banner) banner.style.display = '';
      if (loginBtn) {
        var base = o.loginUrl || '/account/login';
        var returnUrl = window.location.pathname + window.location.search;
        loginBtn.href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(returnUrl);
      }
      return;
    }

    if (banner) banner.style.display = 'none';

    var emailEl = document.getElementById('subx__cp-email');
    if (emailEl && o.customerEmail) emailEl.value = o.customerEmail;
    var fnameEl = document.getElementById('subx__cp-fname');
    if (fnameEl && o.customerFirstName) fnameEl.value = o.customerFirstName;
    var lnameEl = document.getElementById('subx__cp-lname');
    if (lnameEl && o.customerLastName) lnameEl.value = o.customerLastName;
    var phoneEl = document.getElementById('subx__cp-phone');
    if (phoneEl && o.customerPhone) phoneEl.value = o.customerPhone;

    var addr = o.customerAddress;
    if (addr) {
      var addr1El = document.getElementById('subx__cp-addr1');
      if (addr1El && addr.address1) addr1El.value = addr.address1;
      var addr2El = document.getElementById('subx__cp-addr2');
      if (addr2El && addr.address2) addr2El.value = addr.address2;
      var cityEl = document.getElementById('subx__cp-city');
      if (cityEl && addr.city) cityEl.value = addr.city;
      var zipEl = document.getElementById('subx__cp-zip');
      if (zipEl && addr.zip) zipEl.value = addr.zip;
      if (phoneEl && !phoneEl.value && addr.phone) phoneEl.value = addr.phone;
      var countrySel = document.getElementById('subx__cp-country');
      if (countrySel && addr.country) {
          countrySel.value = addr.country;
          this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
      }
      var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
      if (provinceEl && addr.province) provinceEl.value = addr.province;
    }
  };

  SubxCheckoutPopup.prototype.close = function () {
    if (!this._overlay) return;
    this._overlay.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  SubxCheckoutPopup.prototype._fillSummary = function () {
    var o = this._options;
    var nameEl = document.getElementById('subx__cp-product-name');
    if (nameEl) nameEl.textContent = o.productName ? ('You are subscribing to ' + o.productName + ' plan') : '';
    var planEl = document.getElementById('subx__cp-plan-name');
    if (planEl) planEl.textContent = o.sellingPlanName || '';
    var variantEl = document.getElementById('subx__cp-variant-display');
    if (variantEl) variantEl.textContent = o.variantTitle || o.productName || '';
    var qty = o.quantity || 1;
    var planPriceEl = document.getElementById('subx__cp-sum-plan-price');
    if (planPriceEl) planPriceEl.textContent = (o.pricePerCycle || '') + (qty > 1 ? ' × ' + qty : '');
    var totalEl = document.getElementById('subx__cp-sum-total');
    if (totalEl) totalEl.textContent = o.totalPricePerCycle || o.pricePerCycle || '';
    var discountTitleEl = document.getElementById('subx__cp-info-discount-title');
    if (discountTitleEl) {
      discountTitleEl.textContent = o.discountBadgeText ? ('Subscribe once and enjoy ' + o.discountBadgeText + ' off on all future orders') : 'Subscribe once and enjoy ongoing savings on future orders';
    }
    var imgWrap = document.getElementById('subx__cp-img-wrap');
    if (imgWrap) {
      if (o.imageUrl) {
        imgWrap.innerHTML = '<img src="' + o.imageUrl + '" alt="' + (o.productName || '') + '"/>';
      } else {
        imgWrap.innerHTML = '&#128717;';
      }
    }
  };

  SubxCheckoutPopup.prototype._resetForm = function () {
    var ids = ['subx__cp-email', 'subx__cp-fname', 'subx__cp-lname', 'subx__cp-phone',
      'subx__cp-addr1', 'subx__cp-addr2', 'subx__cp-city', 'subx__cp-province-text', 'subx__cp-zip',
      'subx__cp-billing-addr1', 'subx__cp-billing-addr2', 'subx__cp-billing-city',
      'subx__cp-billing-province-text', 'subx__cp-billing-zip'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.value = ''; el.classList.remove('subx__cp-invalid'); }
    });
    var countrySel = document.getElementById('subx__cp-country');
    if (countrySel) { countrySel.value = 'India'; countrySel.classList.remove('subx__cp-invalid'); }
    var stateSel = document.getElementById('subx__cp-province-select');
    if (stateSel) { stateSel.selectedIndex = 0; stateSel.classList.remove('subx__cp-invalid'); }
    var billingCountrySel = document.getElementById('subx__cp-billing-country');
    if (billingCountrySel) { billingCountrySel.value = 'India'; billingCountrySel.classList.remove('subx__cp-invalid'); }
    var billingStateSel = document.getElementById('subx__cp-billing-province-select');
    if (billingStateSel) { billingStateSel.selectedIndex = 0; billingStateSel.classList.remove('subx__cp-invalid'); }
    this._onCountryChange('subx__cp-country', 'subx__cp-province-select', 'subx__cp-province-text');
    this._onCountryChange('subx__cp-billing-country', 'subx__cp-billing-province-select', 'subx__cp-billing-province-text');
    var billingSameCheckbox = document.getElementById('subx__cp-billing-same');
    var billingSection = document.getElementById('subx__cp-billing-section');
    if (billingSameCheckbox) billingSameCheckbox.checked = true;
    if (billingSection) billingSection.style.display = 'none';
    this._resetShipping();
    this._setLoading(false);
  };

  SubxCheckoutPopup.prototype._clearErrors = function () {
    document.querySelectorAll('.subx__cp-field-err').forEach(function (el) {
      el.textContent = ''; el.classList.remove('subx__cp-show');
    });
    var ge = document.getElementById('subx__cp-global-err');
    if (ge) { ge.textContent = ''; ge.classList.remove('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._fieldErr = function (inputId, errId, msg) {
    var inp = document.getElementById(inputId);
    var err = document.getElementById(errId);
    if (inp) inp.classList.add('subx__cp-invalid');
    if (err) { err.textContent = msg; err.classList.add('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._validate = function () {
    this._clearErrors();
    var valid = true;
    var self = this;

    var email = (document.getElementById('subx__cp-email') || {}).value || '';
    email = email.trim();
    if (!email) { self._fieldErr('subx__cp-email', 'subx__cp-email-err', 'Email is required'); valid = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { self._fieldErr('subx__cp-email', 'subx__cp-email-err', 'Enter a valid email address'); valid = false; }

    if (!((document.getElementById('subx__cp-fname') || {}).value || '').trim()) { self._fieldErr('subx__cp-fname', 'subx__cp-fname-err', 'First name is required'); valid = false; }
    if (!((document.getElementById('subx__cp-lname') || {}).value || '').trim()) { self._fieldErr('subx__cp-lname', 'subx__cp-lname-err', 'Last name is required'); valid = false; }

    var phone = ((document.getElementById('subx__cp-phone') || {}).value || '').trim();
    if (!phone) { self._fieldErr('subx__cp-phone', 'subx__cp-phone-err', 'Phone number is required'); valid = false; }
    else if (!/^\+?[\d\s\-(). ]{7,20}$/.test(phone)) { self._fieldErr('subx__cp-phone', 'subx__cp-phone-err', 'Enter a valid phone number'); valid = false; }

    if (!((document.getElementById('subx__cp-addr1') || {}).value || '').trim()) { self._fieldErr('subx__cp-addr1', 'subx__cp-addr1-err', 'Address is required'); valid = false; }
    if (!((document.getElementById('subx__cp-city') || {}).value || '').trim()) { self._fieldErr('subx__cp-city', 'subx__cp-city-err', 'City is required'); valid = false; }

    var provinceEl = self._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    if (!((provinceEl || {}).value || '').trim()) { self._fieldErr(provinceEl ? provinceEl.id : 'subx__cp-province-text', 'subx__cp-province-err', 'State / Province is required'); valid = false; }

    if (!((document.getElementById('subx__cp-country') || {}).value || '').trim()) { self._fieldErr('subx__cp-country', 'subx__cp-country-err', 'Country is required'); valid = false; }
    if (!((document.getElementById('subx__cp-zip') || {}).value || '').trim()) { self._fieldErr('subx__cp-zip', 'subx__cp-zip-err', 'Postal code is required'); valid = false; }

    var billingSame = (document.getElementById('subx__cp-billing-same') || {}).checked;
    if (!billingSame) {
      if (!((document.getElementById('subx__cp-billing-addr1') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-addr1', 'subx__cp-billing-addr1-err', 'Address is required'); valid = false; }
      if (!((document.getElementById('subx__cp-billing-city') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-city', 'subx__cp-billing-city-err', 'City is required'); valid = false; }

      var billingProvinceEl = self._getActiveProvinceEl('subx__cp-billing-province-select', 'subx__cp-billing-province-text');
      if (!((billingProvinceEl || {}).value || '').trim()) { self._fieldErr(billingProvinceEl ? billingProvinceEl.id : 'subx__cp-billing-province-text', 'subx__cp-billing-province-err', 'State / Province is required'); valid = false; }

      if (!((document.getElementById('subx__cp-billing-country') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-country', 'subx__cp-billing-country-err', 'Country is required'); valid = false; }
      if (!((document.getElementById('subx__cp-billing-zip') || {}).value || '').trim()) { self._fieldErr('subx__cp-billing-zip', 'subx__cp-billing-zip-err', 'Postal code is required'); valid = false; }
    }

    // Shipping must be settled before paying. Checked only once the form itself is valid,
    // so the customer sees their field errors first.
    if (valid) {
      var shipping = self._shipping || {};
      if (shipping.state === 'loading') {
        self._showGlobalError('Please wait — shipping is still being calculated.');
        valid = false;
      } else if (shipping.state === 'error') {
        self._showGlobalError("We couldn't calculate shipping. Check the address or tap Try again.");
        valid = false;
      } else if (shipping.state === 'ready' && !shipping.selected) {
        self._showGlobalError('Please choose a shipping option.');
        valid = false;
      } else if (shipping.state === 'idle') {
        // Address is complete but no quote was ever asked for — ask now.
        self._onShippingAddressChanged(true, true);
        self._showGlobalError('Please wait — shipping is still being calculated.');
        valid = false;
      }
    }

    return valid;
  };

  SubxCheckoutPopup.prototype._getFormData = function () {
    var o = this._options;
    var v = function (id) { return ((document.getElementById(id) || {}).value || '').trim(); };
    var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    var shippingAddress = {
      address1: v('subx__cp-addr1'),
      address2: v('subx__cp-addr2'),
      city: v('subx__cp-city'),
      province: ((provinceEl || {}).value || '').trim(),
      country: v('subx__cp-country'),
      zip: v('subx__cp-zip'),
    };

    var billingSame = (document.getElementById('subx__cp-billing-same') || {}).checked;
    var billingAddress;
    if (billingSame) {
        billingAddress = shippingAddress;
    } else {
      var billingProvinceEl = this._getActiveProvinceEl('subx__cp-billing-province-select', 'subx__cp-billing-province-text');
      billingAddress = {
        address1: v('subx__cp-billing-addr1'),
        address2: v('subx__cp-billing-addr2'),
        city: v('subx__cp-billing-city'),
        province: ((billingProvinceEl || {}).value || '').trim(),
        country: v('subx__cp-billing-country'),
        zip: v('subx__cp-billing-zip'),
      };
    }

    var pickedRate = (this._shipping && this._shipping.state === 'ready' && this._shipping.selected) || null;

    return {
      shop: o.shop || '',
      gateway: o.gateway || 'RAZORPAY',
      variantId: o.variantId || '',
      sellingPlanId: o.sellingPlanId || '',
      quantity: o.quantity || 1,
      email: v('subx__cp-email'),
      firstName: v('subx__cp-fname'),
      lastName: v('subx__cp-lname'),
      phone: v('subx__cp-phone'),
      address1: shippingAddress.address1,
      address2: shippingAddress.address2,
      city: shippingAddress.city,
      province: shippingAddress.province,
      country: shippingAddress.country,
      zip: shippingAddress.zip,
      billingAddress: billingAddress,
      // WHICH option was picked — never its price. The server re-quotes it with Shopify
      // and charges Shopify's price. All empty when Shopify had nothing for the address.
      shippingRateHandle: pickedRate ? (pickedRate.handle || '') : '',
      shippingRateTitle: pickedRate ? (pickedRate.title || '') : '',
      // SHIPPING / LOCAL_DELIVERY / PICKUP, and for a pickup, which store.
      shippingRateType: pickedRate ? (pickedRate.type || '') : '',
      pickupLocationId: pickedRate && pickedRate.type === 'PICKUP' ? (pickedRate.locationId || '') : '',
    };
  };

  // ── Shipping ──────────────────────────────────────────────────────────────
  // Shows every delivery option Shopify checkout would show for the address being typed,
  // laid out like checkout: a Ship tab (local delivery first, then shipping rates) and a
  // Pickup tab (store pickup) — the tabs only when the store offers both. Only WHICH option
  // was picked (handle, title, type, pickup store) is ever sent to the server, never a
  // price: pre-order re-quotes it with Shopify and charges Shopify's price, so editing the
  // request can't lower shipping. States:
  //   idle    — shipping address not complete yet
  //   loading — asking the server (Pay disabled)
  //   ready   — options to pick from
  //   none    — Shopify has nothing for this address → "calculated later", Pay allowed
  //   error   — lookup failed or address rejected (Pay disabled, never free shipping)

  SubxCheckoutPopup.prototype._resetShipping = function () {
    clearTimeout(this._shippingTimer);
    this._shipping = {
      state: 'idle',
      rates: [],          // every option, each with its type
      selected: null,
      mode: 'SHIP',       // the open tab: SHIP or PICKUP
      prefs: { SHIP: null, PICKUP: null }, // the customer's last pick on each tab, kept across re-quotes
      prefMode: null,     // the tab of that last pick
      addressKey: null,   // the address the current rates were quoted for
      // Bumped on every new quote; an answer carrying an older number is dropped.
      reqId: ((this._shipping && this._shipping.reqId) || 0) + 1,
    };
    this._renderShipping();
  };

  SubxCheckoutPopup.prototype._getShippingAddress = function () {
    var v = function (id) { return ((document.getElementById(id) || {}).value || '').trim(); };
    var provinceEl = this._getActiveProvinceEl('subx__cp-province-select', 'subx__cp-province-text');
    return {
      address1: v('subx__cp-addr1'),
      address2: v('subx__cp-addr2'),
      city: v('subx__cp-city'),
      province: ((provinceEl || {}).value || '').trim(),
      country: v('subx__cp-country'),
      zip: v('subx__cp-zip'),
    };
  };

  SubxCheckoutPopup.prototype._isShippingAddressReady = function (address) {
    return !!(address.country && address.province && address.city && address.zip);
  };

  // Runs on every shipping-address edit (debounced), on open, and on "Try again". Clears the
  // current pick straight away, so a price quoted for an OLD address can never be paid.
  SubxCheckoutPopup.prototype._onShippingAddressChanged = function (immediate, force) {
    var self = this;
    var sh = this._shipping;
    if (!sh) return;
    var address = this._getShippingAddress();
    var key = JSON.stringify(address);
    // One edit fires input AND change (and change again on blur) — don't re-quote when
    // nothing actually changed.
    if (!force && key === sh.addressKey && sh.state !== 'error' && sh.state !== 'idle') return;

    clearTimeout(this._shippingTimer);
    sh.reqId++;
    sh.rates = [];
    sh.selected = null;
    sh.addressKey = key;
    sh.state = this._isShippingAddressReady(address) ? 'loading' : 'idle';
    this._renderShipping();
    if (sh.state !== 'loading') return;
    this._shippingTimer = setTimeout(function () { self._calculateShippingRates(); }, immediate ? 0 : 600);
  };

  SubxCheckoutPopup.prototype._calculateShippingRates = function () {
    var self = this;
    var o = this._options || {};
    var sh = this._shipping;
    var address = this._getShippingAddress();
    if (!sh || !this._isShippingAddressReady(address)) return;

    var reqId = ++sh.reqId;
    sh.addressKey = JSON.stringify(address);
    sh.state = 'loading';
    sh.rates = [];
    sh.selected = null;
    this._renderShipping();

    var shop = o.shop || (window.Shopify && window.Shopify.shop) || '';
    var isStale = function () { return sh !== self._shipping || reqId !== sh.reqId; };

    fetch(SUBX_APP_URL + '/api/external/checkout/shipping-rates?shop=' + encodeURIComponent(shop), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: shop,
        sellingPlanId: o.sellingPlanId || '',
        line_items: { variantId: o.variantId || '', quantity: Number(o.quantity || 1) },
        shipping_address: address,
      }),
    })
    .then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || !body.status || !Array.isArray(body.result)) {
          throw new Error((body && body.message) || 'Shipping rate request failed');
        }
        return body.result;
      });
    })
    .then(function (rates) {
      if (isStale()) return; // a newer address is being quoted — drop this answer
      sh.rates = rates;
      sh.state = rates.length ? 'ready' : 'none';
      sh.selected = rates.length ? self._findPreferredRate(rates) : null;
      sh.mode = self._isPickup(sh.selected) ? 'PICKUP' : 'SHIP';
      self._renderShipping();
    })
    .catch(function (err) {
      if (isStale()) return;
      console.error('[SubxCheckoutPopup] Shipping rate error:', err);
      sh.rates = [];
      sh.selected = null;
      sh.state = 'error';
      self._renderShipping();
    });
  };

  SubxCheckoutPopup.prototype._isPickup = function (rate) {
    return !!rate && rate.type === 'PICKUP';
  };

  // The options on one tab, in Shopify's order. SHIP = local delivery + shipping rates.
  SubxCheckoutPopup.prototype._ratesForMode = function (mode) {
    var self = this;
    var rates = (this._shipping && this._shipping.rates) || [];
    return rates.filter(function (rate) { return self._isPickup(rate) === (mode === 'PICKUP'); });
  };

  // The option in `rates` that is the same as an earlier pick: same handle, else the same
  // pickup store, else the same type and title. null when it's gone.
  SubxCheckoutPopup.prototype._matchPick = function (rates, pick) {
    if (!pick) return null;
    var i;
    for (i = 0; i < rates.length; i++) {
      if (pick.handle && rates[i].handle === pick.handle) return rates[i];
    }
    for (i = 0; i < rates.length; i++) {
      if (pick.locationId && rates[i].locationId === pick.locationId) return rates[i];
    }
    for (i = 0; i < rates.length; i++) {
      if (pick.title && rates[i].title === pick.title && (rates[i].type || '') === pick.type) return rates[i];
    }
    return null;
  };

  // Keeps the customer's earlier pick across re-quotes (address edit, retry); otherwise
  // what checkout picks — the first Ship option, or the first store when the address has
  // nothing to ship.
  SubxCheckoutPopup.prototype._findPreferredRate = function (rates) {
    var self = this;
    var sh = this._shipping || {};
    var kept = sh.prefMode && sh.prefs ? this._matchPick(rates, sh.prefs[sh.prefMode]) : null;
    if (kept) return kept;
    var ship = rates.filter(function (rate) { return !self._isPickup(rate); });
    return ship.length ? ship[0] : rates[0];
  };

  SubxCheckoutPopup.prototype._rememberPick = function (rate) {
    var sh = this._shipping;
    var mode = this._isPickup(rate) ? 'PICKUP' : 'SHIP';
    sh.prefs[mode] = { handle: rate.handle, title: rate.title, type: rate.type || '', locationId: rate.locationId || '' };
    sh.prefMode = mode;
  };

  SubxCheckoutPopup.prototype._selectShippingRate = function (index) {
    var sh = this._shipping;
    if (!sh || sh.state !== 'ready' || !sh.rates[index]) return;
    sh.selected = sh.rates[index];
    this._rememberPick(sh.selected);
    this._renderShippingPrice();
    this._updateSubscriptionTotal();
  };

  // Ship / Pickup tab: shows that tab's options and picks the customer's earlier choice on
  // it, or its first option.
  SubxCheckoutPopup.prototype._selectShippingMode = function (mode) {
    var sh = this._shipping;
    if (!sh || sh.state !== 'ready' || sh.mode === mode) return;
    var list = this._ratesForMode(mode);
    if (!list.length) return;
    sh.mode = mode;
    sh.selected = this._matchPick(list, sh.prefs[mode]) || list[0];
    this._rememberPick(sh.selected);
    this._renderShipping();
  };

  SubxCheckoutPopup.prototype._formatMoney = function (amount, currency) {
    var n = Number(amount || 0);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'INR' }).format(n);
    } catch (e) {
      return (currency ? currency + ' ' : '') + n.toFixed(2);
    }
  };

  // Rate titles come from the store's shipping settings — escaped before going into HTML.
  SubxCheckoutPopup.prototype._escapeHtml = function (value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  // "₹50.00 × 3 deliveries = ₹150.00" for a prepaid plan, plain "₹50.00" otherwise.
  SubxCheckoutPopup.prototype._describeRate = function (rate) {
    var deliveries = Number(rate.deliveries || 1);
    var total = this._formatMoney(rate.total || rate.price, rate.currency);
    if (deliveries > 1) {
      return this._formatMoney(rate.price, rate.currency) + ' × ' + deliveries + ' deliveries = ' + total;
    }
    return total;
  };

  // "Free" for ₹0 — pickup, free local delivery — like checkout; otherwise the billing's total.
  SubxCheckoutPopup.prototype._priceText = function (rate) {
    var amount = Number(rate.total || rate.price || 0);
    return amount === 0 ? 'Free' : this._formatMoney(amount, rate.currency);
  };

  SubxCheckoutPopup.prototype._renderShippingPrice = function () {
    var priceEl = document.getElementById('subx__cp-shipping-price');
    if (!priceEl) return;
    var sh = this._shipping || {};
    var labelEl = document.getElementById('subx__cp-shipping-label');
    if (labelEl) labelEl.textContent = sh.state === 'ready' && this._isPickup(sh.selected) ? 'Pickup' : 'Shipping';
    if (sh.state === 'loading') {
      priceEl.textContent = 'Calculating…';
    } else if (sh.state === 'ready' && sh.selected) {
      priceEl.textContent = this._priceText(sh.selected);
    } else {
      priceEl.textContent = '—';
    }
  };

  SubxCheckoutPopup.prototype._renderShipping = function () {
    var self = this;
    var sh = this._shipping || { state: 'idle', rates: [] };
    var optionsEl = document.getElementById('subx__cp-shipping-options');
    var listEl = document.getElementById('subx__cp-shipping-list');
    var statusEl = document.getElementById('subx__cp-shipping-status');
    if (!optionsEl || !listEl || !statusEl) return;

    this._renderShippingPrice();

    var tabsEl = document.getElementById('subx__cp-ship-tabs');
    var optionsLabelEl = document.getElementById('subx__cp-shipping-options-label');
    if (sh.state === 'ready') {
      var hasShip = this._ratesForMode('SHIP').length > 0;
      var hasPickup = this._ratesForMode('PICKUP').length > 0;
      // Rows for the open tab only; each radio's value is its index in the full list.
      listEl.innerHTML = sh.rates.map(function (rate, index) {
        if (self._isPickup(rate) !== (sh.mode === 'PICKUP')) return '';
        var deliveries = Number(rate.deliveries || 1);
        var sub = '';
        if (self._isPickup(rate)) {
          sub = rate.instructions || '';          // e.g. "Usually ready in 24 hours"
        } else if (deliveries > 1 && Number(rate.price) > 0) {
          sub = self._describeRate(rate);          // "₹50.00 × 3 deliveries = ₹150.00"
        }
        return '<label class="subx__cp-ship-rate">' +
          '<input type="radio" name="subx_shipping_rate" value="' + index + '"' + (rate === sh.selected ? ' checked' : '') + '/>' +
          '<span class="subx__cp-ship-rate-title">' + self._escapeHtml(rate.title || (self._isPickup(rate) ? 'Store pickup' : 'Shipping')) +
            (sub ? '<span class="subx__cp-ship-rate-sub">' + self._escapeHtml(sub) + '</span>' : '') +
          '</span>' +
          '<span class="subx__cp-ship-rate-price">' + self._escapeHtml(self._priceText(rate)) + '</span>' +
          '</label>';
      }).join('');
      listEl.querySelectorAll('input[name="subx_shipping_rate"]').forEach(function (input) {
        input.addEventListener('change', function () { self._selectShippingRate(Number(input.value)); });
      });
      if (tabsEl) {
        tabsEl.style.display = hasShip && hasPickup ? '' : 'none';
        tabsEl.querySelectorAll('.subx__cp-ship-tab').forEach(function (tab) {
          var active = tab.getAttribute('data-mode') === sh.mode;
          tab.classList.toggle('subx__cp-active', active);
          tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      if (optionsLabelEl) {
        optionsLabelEl.textContent = hasShip && hasPickup ? 'Delivery Method' : (hasPickup ? 'Pickup Location' : 'Shipping Method');
      }
      optionsEl.style.display = '';
    } else {
      listEl.innerHTML = '';
      if (tabsEl) tabsEl.style.display = 'none';
      optionsEl.style.display = 'none';
    }

    statusEl.className = 'subx__cp-ship-status';
    statusEl.innerHTML = '';
    if (sh.state === 'idle') {
      statusEl.textContent = 'Enter your address to see shipping';
    } else if (sh.state === 'none') {
      statusEl.textContent = 'Shipping will be calculated later';
    } else if (sh.state === 'error') {
      statusEl.className = 'subx__cp-ship-status subx__cp-ship-error';
      statusEl.appendChild(document.createTextNode("Couldn't calculate shipping. Check the address or "));
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'subx__cp-ship-retry';
      retry.textContent = 'Try again';
      retry.addEventListener('click', function () { self._onShippingAddressChanged(true, true); });
      statusEl.appendChild(retry);
    }
    statusEl.style.display = statusEl.childNodes.length ? '' : 'none';

    this._updateSubscriptionTotal();
    this._syncSubmitButton();
  };

  SubxCheckoutPopup.prototype._updateSubscriptionTotal = function () {
    var o = this._options || {};
    var totalEl = document.getElementById('subx__cp-sum-total');
    if (!totalEl) return;
    var sh = this._shipping || {};
    var rate = sh.state === 'ready' ? sh.selected : null;
    if (!rate) {
      // No shipping chosen (yet) — the plan total, exactly as before.
      totalEl.textContent = o.totalPricePerCycle || o.pricePerCycle || '';
      return;
    }
    var currency = rate.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    totalEl.textContent = this._formatMoney(Number(o.totalPriceNumeric || 0) + Number(rate.total || rate.price || 0), currency);
  };

  // Pay stays disabled while shipping is loading or failed — never pay on a stale or
  // missing quote. Left alone while a submit is in flight (_setLoading owns it then).
  SubxCheckoutPopup.prototype._syncSubmitButton = function () {
    var btn = document.getElementById('subx__cp-submit');
    if (!btn || this._submitting) return;
    var state = this._shipping && this._shipping.state;
    btn.disabled = state === 'loading' || state === 'error';
  };

  SubxCheckoutPopup.prototype._setLoading = function (on) {
    var btn = document.getElementById('subx__cp-submit');
    if (!btn) return;
    this._submitting = !!on;
    btn.disabled = !!on;
    btn.textContent = on ? 'Processing…' : 'Proceed to Payment';
    if (!on) this._syncSubmitButton();
  };

  SubxCheckoutPopup.prototype._showGlobalError = function (msg) {
    var el = document.getElementById('subx__cp-global-err');
    if (el) { el.textContent = msg; el.classList.add('subx__cp-show'); }
  };

  SubxCheckoutPopup.prototype._handleSubmit = function () {
    if (!this._validate()) return;
    var data = this._getFormData();
    var self = this;
    var shop = data.shop || (window.Shopify && window.Shopify.shop) || '';
    // Shared pre-order route — dispatches to whichever gateway (Razorpay, Paystack,
    // or Razorpay Recurring) this shop actually has connected, instead of hardcoding
    // to the original Razorpay-only endpoint.
    var url = SUBX_APP_URL + '/api/external/checkout/pre-order?shop=' + encodeURIComponent(shop);

    this._clearErrors();
    this._setLoading(true);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    .then(function (response) { return response.json(); })
    .then(function (result) {
      if (result.status && result.result && result.result.key_id &&
          (result.result.subscription_id || (result.result.order_id && result.result.customer_id))) {
        // Razorpay popup flow (either Subscriptions mode or Recurring/tokenization
        // mode): pay in-page instead of leaving the store, so we can send the
        // customer back to their account afterwards.
        self._openRazorpayCheckout(result.result);
      } else if (result.status && result.result && result.result.redirect_url) {
        // Paystack, and any Razorpay Recurring response that didn't include the
        // above (older backend), still redirect to their own hosted payment page.
        window.location.href = result.result.redirect_url;
      } else {
        self._setLoading(false);
        self._showGlobalError(result.message || 'Something went wrong. Please try again.');
        // Re-quote in case the server refused a rate that's no longer offered
        // ("Shipping options have changed"). Keeps the customer's pick if still there.
        self._onShippingAddressChanged(true, true);
      }
    })
    .catch(function (err) {
      console.error('[SubxCheckoutPopup] Network error:', err);
      self._setLoading(false);
      self._showGlobalError('Network error. Please check your connection and try again.');
    });
  };

  // Opens Razorpay's Checkout.js modal for the mandate/first-charge authorization
  // right on the store page, for either Razorpay gateway this app supports:
  //   - Subscriptions mode: subscription_id. subscription.authenticated /
  //     subscription.charged webhooks provision the contract server-side (see
  //     razorpay-contract-service.js).
  //   - Recurring/tokenization mode: order_id + customer_id (Standard Checkout
  //     with recurring:true). payment.captured/payment.authorized webhooks
  //     provision the contract server-side (see webhook-handler.js).
  // Either way this only needs to hand the customer back to their account once
  // Razorpay confirms the payment — provisioning itself is webhook-driven, not
  // dependent on this popup succeeding or even staying open.
  SubxCheckoutPopup.prototype._openRazorpayCheckout = function (payload) {
    var self = this;
    loadRazorpayCheckout().then(function (Razorpay) {
      var options = {
        key: payload.key_id,
        prefill: payload.prefill || {},
        handler: function () {
          window.location.href = SUBX_ACCOUNT_SUBSCRIPTIONS_URL || (window.location.origin + '/account');
        },
        modal: {
          ondismiss: function () {
            self._setLoading(false);
          },
        },
      };
      if (payload.subscription_id) {
        options.subscription_id = payload.subscription_id;
      } else {
        options.order_id = payload.order_id;
        options.customer_id = payload.customer_id;
        options.recurring = true;
      }
      var rzp = new Razorpay(options);
      rzp.on('payment.failed', function (resp) {
        self._setLoading(false);
        self._showGlobalError((resp && resp.error && resp.error.description) || 'Payment failed. Please try again.');
      });
      rzp.open();
    }).catch(function (err) {
      console.error('[SubxCheckoutPopup] Razorpay Checkout load failed:', err);
      if (payload.redirect_url) {
        // Better than a dead end: fall back to the hosted page if the script failed to load.
        window.location.href = payload.redirect_url;
      } else {
        self._setLoading(false);
        self._showGlobalError('Could not open payment window. Please try again.');
      }
    });
  };

  if (!window.SUBXCheckoutPopup) {
    console.log('[SUBX-FIX] First load — creating window.SUBXCheckoutPopup.');
    window.SUBXCheckoutPopup = new SubxCheckoutPopup();
  } else {
    console.warn('[SUBX-FIX] Duplicate script execution detected — window.SUBXCheckoutPopup already existed, skipped creating a second popup instance.');
  }
}());
